import { createComponent } from '@lit/react';
import { Header } from '@pocketoutdoormedia/header-wc';
import type { ReactNode } from 'react';
import React from 'react';
import { getNavigationConfig } from 'helpers/outside-packages/getNavigationConfig';
import { EVENTS } from 'helpers/outside-packages/constants';
import type { HeaderUserData } from 'helpers/outside-packages/types';

const HeaderLitComponent = createComponent({
  elementClass: Header,
  events: EVENTS,
  react: React,
  tagName: 'out-header'
});

type HeaderWCProps = {
  children?: ReactNode;
  userData: HeaderUserData;
};

const HeaderWC = ({ children, userData }: HeaderWCProps) => {
  const navConfig = getNavigationConfig();

  return (
    <HeaderLitComponent theme="dark" userData={userData} {...navConfig}>
      <div slot="header-logo">{children}</div>
    </HeaderLitComponent>
  );
};

export default HeaderWC;
